import React, { Component, createRef } from "react";
import "component/listItem/CategoryType5/styles.scss";
import iconDefault from "assets/images/iconDefault.png";
import { PlayIcon } from "component/icons";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";
import { currencyFormatter } from "utils/currencyHelper";

const ICON_DEFAULT = "ICON_DEFAULT";

class CategoryType5 extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.mainComponent = createRef();
    this.state = {
      hovered: false,
      isVisible: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
    }
  }

  render() {
    let { game, gameLimit } = this.props;

    return (
      <div
        className={`${this.props.className} category-type-5`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        <div>
          <div className="img-holder">
            <div className="jackpot-amount">
              {game && (
                <span>
                  {this.getTotalPool(this.state.jackpotPool, game, false)}
                </span>
              )}
            </div>
            {game && this.state.isVisible && (
              <img
                src={`${setDefaultImageFormat(
                  game
                    .getIn(["images", "url"])
                    .replace("width=90", "width=200") + "&theme=dark",
                  this.props.imageFormat.get("logoRound")
                )}`}
                className="icon d-none"
                alt={game.get("name")}
                onLoad={({ currentTarget }) => {
                  currentTarget.classList.remove("d-none");
                  this.refs[ICON_DEFAULT].classList.add("d-none");
                }}
              />
            )}
            <img
              ref={ICON_DEFAULT}
              src={iconDefault}
              className="icon"
              alt="icon"
            />
            {gameLimit && gameLimit.size > 0 && (
              <div className="game-limits">
                <span className="min-bet">
                  {currencyFormatter(gameLimit.get('minBet'), {
                    currency: this.props.currency,
                  })}  
                </span>   
                <span className="max-bet">
                  - {currencyFormatter(gameLimit.get('maxBet'), {
                    currency: this.props.currency,
                  })}  
                </span>   
              </div>
            )}            
            {!this.props.isOneClickPlayEnabled && (
              <div
                className={`actions w-100 h-100 justify-content-center align-items-center ${
                  this.state.hovered ? "d-flex" : "d-none"
                }`}
              >
                {this.props.linkReal && (
                  <div
                    className="play-button text-center"
                    onClick={(event) => {
                      if (this.props.onClick) {
                        this.props.onClick(this.props.linkReal.get("rel"));
                      }
                      event.stopPropagation();
                    }}
                  >
                    <PlayIcon />
                  </div>
                )}
                {this.props.linkDemo && (
                  <button
                    className="demo-button btn btn-secondary btn-xs"
                    onClick={(event) => {
                      if (this.props.onClick) {
                        this.props.onClick(this.props.linkDemo.get("rel"));
                      }
                      event.stopPropagation();
                    }}
                  >
                    {this.props.linkDemo.get("name")}
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="details">
            <div className="name">
              {game && <span>{game.get("name")}</span>}
              {!game && <span className="dummy">XXXXXXXXXX</span>}
            </div>
            <div className="provider">
              {game && <span>{game.get("provider")}</span>}
              {!game && <span className="dummy">XXXXXXXXXXX</span>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoryType5;
